import { AdvAttachDTO } from '@fontanka/news-api-client';
import { AdvAttach } from '../../../domain';

export const createAdvAttach = (attach: AdvAttachDTO, id: number): AdvAttach => ({
  type: attach.type,
  value: {
    id
  }
});
